<ion-header >
  <div *ngIf="platformSRV.isNative.value" class="add-margin-top-to-safe-area"></div>
  <ion-button fill="clear" expand="block" color="light" (click)="onCloseModal()" style="text-align: center;">Close<ion-icon slot="start"  name="close"></ion-icon></ion-button>


</ion-header>
<ion-content>
  <swiper [config]="config" #swiper >
    <ng-template swiperSlide>
      <div class="swiper-zoom-container" style=" 
      height: 100%;display: flex;
  justify-content: center;
  align-items: center;">
        <img src="{{imageSource}}" style="max-height: 100%;">
      </div>

    </ng-template>
  </swiper>
</ion-content>
